// Material Kit 2 React pages
import QuestionPaper from "pages/ElearningAndQuestionPapers/Courses";

export default function QuestionPaperPage() {
  return <QuestionPaper />;
}
